module.exports = __webpack_public_path__ + "img/mission-diversity-rights.jpg?85d5e45f93fe4ab9bdeaf776a3df55ae";